import React from 'react';
import { motion } from 'framer-motion';
import { Mail, MessageSquare, MapPin } from 'lucide-react';
import { Button } from '../components/Button';
export const Contact = () => {
  return <div className="min-h-screen pt-32 pb-24 relative overflow-hidden" data-id="element-169">
      {/* Background glow */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-lab-violet/10 rounded-full blur-[120px] pointer-events-none" data-id="element-170" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-171">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-172">
          {/* Left: Info */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} data-id="element-173">
            <h1 className="text-4xl md:text-6xl font-display font-bold mb-6" data-id="element-174">
              Inicia la <span className="text-gradient" data-id="element-175">Transmisión</span>
            </h1>
            <p className="text-xl text-lab-muted font-light mb-12 max-w-md" data-id="element-176">
              ¿Preguntas sobre arquitecturas personalizadas o implementaciones
              corporativas? Nuestro equipo de ingenieros cognitivos está listo.
            </p>

            <div className="space-y-8" data-id="element-177">
              <div className="flex items-start gap-4" data-id="element-178">
                <div className="w-12 h-12 rounded-full glass-panel flex items-center justify-center shrink-0 border-white/10" data-id="element-179">
                  <Mail className="text-lab-neon" size={20} data-id="element-180" />
                </div>
                <div data-id="element-181">
                  <h3 className="font-display font-semibold text-white mb-1" data-id="element-182">
                    Comunicaciones Generales
                  </h3>
                  <p className="text-lab-muted text-sm mb-2" data-id="element-183">
                    Para soporte de sistemas y consultas.
                  </p>
                  <a href="mailto:hello@clvnlrr.com" className="text-white hover:text-lab-neon transition-colors font-mono text-sm" data-id="element-184">
                    hello@clvnlrr.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-185">
                <div className="w-12 h-12 rounded-full glass-panel flex items-center justify-center shrink-0 border-white/10" data-id="element-186">
                  <MessageSquare className="text-lab-blueLight" size={20} data-id="element-187" />
                </div>
                <div data-id="element-188">
                  <h3 className="font-display font-semibold text-white mb-1" data-id="element-189">
                    Soporte Prioritario
                  </h3>
                  <p className="text-lab-muted text-sm mb-2" data-id="element-190">
                    Solo para usuarios con sistemas activos.
                  </p>
                  <span className="text-white font-mono text-sm" data-id="element-191">
                    Acceso vía Dashboard
                  </span>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-192">
                <div className="w-12 h-12 rounded-full glass-panel flex items-center justify-center shrink-0 border-white/10" data-id="element-193">
                  <MapPin className="text-lab-muted" size={20} data-id="element-194" />
                </div>
                <div data-id="element-195">
                  <h3 className="font-display font-semibold text-white mb-1" data-id="element-196">
                    Sede Digital
                  </h3>
                  <p className="text-lab-muted text-sm" data-id="element-197">
                    Operando globalmente, descentralizados.
                  </p>
                  <span className="text-lab-muted font-mono text-sm" data-id="element-198">
                    Latitud: 0.0000, Longitud: 0.0000
                  </span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right: Form */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} className="glass-card p-8 md:p-10 rounded-3xl" data-id="element-199">
            <h2 className="text-2xl font-display font-bold mb-8" data-id="element-200">
              Enviar Mensaje
            </h2>
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-201">
              <div className="grid grid-cols-2 gap-6" data-id="element-202">
                <div className="space-y-2" data-id="element-203">
                  <label className="text-xs font-mono text-lab-muted uppercase tracking-wider" data-id="element-204">
                    Nombre
                  </label>
                  <input type="text" className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-lab-violetLight/50 transition-colors" placeholder="John Doe" data-id="element-205" />
                </div>
                <div className="space-y-2" data-id="element-206">
                  <label className="text-xs font-mono text-lab-muted uppercase tracking-wider" data-id="element-207">
                    Email
                  </label>
                  <input type="email" className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-lab-violetLight/50 transition-colors" placeholder="john@empresa.com" data-id="element-208" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-209">
                <label className="text-xs font-mono text-lab-muted uppercase tracking-wider" data-id="element-210">
                  Asunto
                </label>
                <select className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-lab-violetLight/50 transition-colors appearance-none" data-id="element-211">
                  <option value="support" className="bg-lab-dark" data-id="element-212">
                    Soporte Técnico
                  </option>
                  <option value="sales" className="bg-lab-dark" data-id="element-213">
                    Ventas Corporativas
                  </option>
                  <option value="other" className="bg-lab-dark" data-id="element-214">
                    Otros
                  </option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-215">
                <label className="text-xs font-mono text-lab-muted uppercase tracking-wider" data-id="element-216">
                  Mensaje
                </label>
                <textarea rows={4} className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-lab-violetLight/50 transition-colors resize-none" placeholder="Describe tu requerimiento..." data-id="element-217"></textarea>
              </div>

              <Button variant="primary" fullWidth className="mt-4" data-id="element-218">
                Transmitir Mensaje
              </Button>
            </form>
          </motion.div>
        </div>
      </div>
    </div>;
};